import { Injectable, inject } from '@angular/core';
import { HttpService } from '../http/http.service';
import { WagerTier } from 'src/app/model/wager/wager';
import { WagerApi } from '../../api/wager-api';
import { BehaviorSubject, Observable } from 'rxjs';
import { JobService } from '../job/job.service';
import { PAGE } from 'src/app/routes';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TiersService {
  private httpService = inject(HttpService);
  private jobService = inject(JobService);
  private router = inject(Router);

  private isDirty = true;
  private tiersData = new BehaviorSubject<WagerTier[] | undefined>(undefined);

  get tiersData$(): Observable<WagerTier[] | undefined> {
    return this.tiersData.asObservable();
  }

  async fetchTiers(): Promise<void> {
    const job = this.jobService
      .create(async () => {
        await this.refresh();
      })
      .showNoInternetRetry()
      .showSpinner();

    job
      .addErrorHandler()
      .showFatalError()
      .onCancel(() => {
        this.router.navigate([PAGE.LOADING]);
      });
    return job.runNoThrow();
  }

  setDirty(): void {
    this.isDirty = true;
  }

  async refresh(): Promise<void> {
    if (!this.isDirty) {
      return;
    }

    const tiers = (await WagerApi.request(this.httpService).tiers()).data;
    this.tiersData.next(tiers);
    this.isDirty = false;
  }
}
